import * as React from 'react'

interface IProps {
  color: string
}

function Loader(props: IProps) {
  const { color } = props

  return (
    <svg width="35px" height="35px" viewBox="0 15 100 100">
      <g transform="rotate(0 50 50)">
        <rect x="47.5" y="26" rx="0" ry="0" width="5" height="12" fill={color}>
          <animate
            attributeName="opacity"
            values="1;0"
            keyTimes="0;1"
            dur="0.9615384615384615s"
            begin="-0.8547008547008548s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
      <g transform="rotate(40 50 50)">
        <rect x="47.5" y="26" rx="0" ry="0" width="5" height="12" fill={color}>
          <animate
            attributeName="opacity"
            values="1;0"
            keyTimes="0;1"
            dur="0.9615384615384615s"
            begin="-0.7478632478632479s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
      <g transform="rotate(80 50 50)">
        <rect x="47.5" y="26" rx="0" ry="0" width="5" height="12" fill={color}>
          <animate
            attributeName="opacity"
            values="1;0"
            keyTimes="0;1"
            dur="0.9615384615384615s"
            begin="-0.6410256410256411s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
      <g transform="rotate(120 50 50)">
        <rect x="47.5" y="26" rx="0" ry="0" width="5" height="12" fill={color}>
          <animate
            attributeName="opacity"
            values="1;0"
            keyTimes="0;1"
            dur="0.9615384615384615s"
            begin="-0.5341880341880342s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
      <g transform="rotate(160 50 50)">
        <rect x="47.5" y="26" rx="0" ry="0" width="5" height="12" fill={color}>
          <animate
            attributeName="opacity"
            values="1;0"
            keyTimes="0;1"
            dur="0.9615384615384615s"
            begin="-0.4273504273504274s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
      <g transform="rotate(200 50 50)">
        <rect x="47.5" y="26" rx="0" ry="0" width="5" height="12" fill={color}>
          <animate
            attributeName="opacity"
            values="1;0"
            keyTimes="0;1"
            dur="0.9615384615384615s"
            begin="-0.32051282051282054s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
      <g transform="rotate(240 50 50)">
        <rect x="47.5" y="26" rx="0" ry="0" width="5" height="12" fill={color}>
          <animate
            attributeName="opacity"
            values="1;0"
            keyTimes="0;1"
            dur="0.9615384615384615s"
            begin="-0.2136752136752137s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
      <g transform="rotate(280 50 50)">
        <rect x="47.5" y="26" rx="0" ry="0" width="5" height="12" fill={color}>
          <animate
            attributeName="opacity"
            values="1;0"
            keyTimes="0;1"
            dur="0.9615384615384615s"
            begin="-0.10683760683760685s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
      <g transform="rotate(320 50 50)">
        <rect x="47.5" y="26" rx="0" ry="0" width="5" height="12" fill={color}>
          <animate
            attributeName="opacity"
            values="1;0"
            keyTimes="0;1"
            dur="0.9615384615384615s"
            begin="0s"
            repeatCount="indefinite"
          />
        </rect>
      </g>
    </svg>
  )
}

export default React.memo(Loader)
